import { render } from "./LeaveTypeDropdown.vue?vue&type=template&id=a189613c&scoped=true"
import script from "./LeaveTypeDropdown.vue?vue&type=script&lang=js"
export * from "./LeaveTypeDropdown.vue?vue&type=script&lang=js"

import "./LeaveTypeDropdown.vue?vue&type=style&index=0&id=a189613c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a189613c"]])

export default __exports__